<li
  class="nav-item dropdown-notifications navbar-dropdown dropdown animate__animated animate__delay-4-0s"
  [ngClass]="isRTL==true?'animate__fadeInLeft':'animate__fadeInRight'"
>
  <a
    class="nav-link dropdown-toggle hide-arrow"
    href="javascript:void(0);"
    data-bs-toggle="dropdown"
    aria-expanded="false"
    ngbTooltip="{{ 'Notification' | translate }}"
  >
    <i class="bx bx-bell bx-sm"></i>
    <span
      *ngIf="unreadCount && unreadCount > 0"
      class="badge bg-danger rounded-pill badge-notifications"
      >{{ unreadCount }}</span
    >
  </a>

  <ul class="dropdown-menu dropdown-menu-end py-0" data-bs-auto-close="outside">
    <li class="dropdown-menu-header border-bottom">
      <div class="dropdown-header d-flex align-items-center py-1">
        <h5 class="text-body mb-0 me-auto secondary-font">
          {{ "Notification" | translate }}
        </h5>
        <a
          href="javascript:void(0)"
          class="dropdown-notifications-all text-body"
          (click)="clearList()"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          ngbTooltip="{{ 'ReadMarkForAll' | translate }}"
          ><i class="bx fs-4 bx-envelope-open"></i
        ></a>
      </div>
    </li>

    <li class="dropdown-notifications-list scrollable-container">
      <ul class="list-group list-group-flush">
        <ng-container *ngFor="let item of apiResponse; let i = index">
          <li
            class="list-group-item list-group-item-action dropdown-notifications-item py-0 px-1"
            [ngClass]="{
              'update-alert': item.notificationType == 0,
              'check-reminder': item.notificationType == 1,
              event: item.notificationType == 2,
              'expire-date': item.notificationType == 3,
              'need-to-buy': item.notificationType == 4,
              'mark-as-read': item.isRead
            }"
          >
            <div class="row position-relative">
              <ng-container *ngIf="item.notificationType == 1">
                <div class="col-10">
                  <h6 class="badge bg-danger mb-1">
                    {{ "Check" | translate }}
                  </h6>
                </div>
                <div class="col-2">
                  <span
                    class="badge badge-dot"
                    [ngClass]="{
                      'update-alert': item.notificationType == 0,
                      'check-reminder': item.notificationType == 1,
                      event: item.notificationType == 2,
                      'expire-date': item.notificationType == 3,
                      'need-to-buy': item.notificationType == 4
                    }"
                  ></span>
                </div>
                <div class="col-12">
                  <p class="mb-1">{{ item.description }}</p>
                </div>
                <div class="col-12">
                  <small class="text-muted"
                    >{{ "checkPayTo" | translate }} :
                  </small>
                  <small>{{ item.title }}</small>
                </div>
                <div class="col-6">
                  <small class="text-muted"
                    >{{ "checkPriceNumber" | translate }} :
                  </small>
                  <small>{{
                    item.shortDescription | dataType : "price"
                  }}</small>
                </div>
                <div class="col-6">
                  <small class="text-muted">{{ "Date" | translate }} : </small>
                  <small>{{ item.dateTime | dataType : "" }}</small>
                </div>
              </ng-container>
              <ng-container *ngIf="item.notificationType == 2">
                <div class="col-10">
                  <h6 class="badge bg-danger mb-1">
                    {{ "Check" | translate }}
                  </h6>
                </div>
                <div class="col-2">
                  <span
                    class="badge badge-dot"
                    [ngClass]="{
                      'update-alert': item.notificationType == 0,
                      'check-reminder': item.notificationType == 1,
                      event: item.notificationType == 2,
                      'expire-date': item.notificationType == 3,
                      'need-to-buy': item.notificationType == 4
                    }"
                  ></span>
                </div>
                <div class="col-12">
                  <p class="mb-1">{{ item.description }}</p>
                </div>
                <div class="col-12">
                  <small class="text-muted"
                    >{{ "checkPayTo" | translate }} :
                  </small>
                  <small>{{ item.title }}</small>
                </div>
                <div class="col-6">
                  <small class="text-muted"
                    >{{ "checkPriceNumber" | translate }} :
                  </small>
                  <small>{{
                    item.shortDescription | dataType : "price"
                  }}</small>
                </div>
                <div class="col-6">
                  <small class="text-muted">{{ "Date" | translate }} : </small>
                  <small>{{ item.dateTime | dataType : "" }}</small>
                </div>
              </ng-container>
              <ng-container *ngIf="item.notificationType == 3">
                <div class="col-10">
                  <h6 class="badge bg-warning mb-1">
                    {{ "InventoryExpire" | translate }}
                  </h6>
                </div>
                <div class="col-2">
                  <a
                    href="javascript:void(0)"
                    class="dropdown-notifications-read"
                  >
                    <span
                      class="badge badge-dot"
                      [ngClass]="{
                        'update-alert': item.notificationType == 0,
                        'check-reminder': item.notificationType == 1,
                        event: item.notificationType == 2,
                        'expire-date': item.notificationType == 3,
                        'need-to-buy': item.notificationType == 4
                      }"
                    ></span>
                  </a>
                </div>
                <div class="col-12">
                  <p class="mb-1">{{ item.title }}</p>
                </div>
                <div class="col-4">
                  <small class="text-muted">{{ "Stock" | translate }} : </small>
                  <small>{{ item.description }}</small>
                </div>
                <div class="col-4">
                  <small class="text-muted"
                    >{{ "Inventory" | translate }} :
                  </small>
                  <small>{{ item.shortDescription }}</small>
                </div>
                <div class="col-4">
                  <small class="text-muted">{{ "Date" | translate }} : </small>
                  <small>{{ item.dateTime | dataType : "" }}</small>
                </div>
              </ng-container>
              <ng-container *ngIf="item.notificationType == 4">
                <div class="col-10">
                  <h6 class="badge bg-info mb-1">
                    {{ "InventorySellNeed" | translate }}
                  </h6>
                </div>
                <div class="col-2">
                  <a
                    href="javascript:void(0)"
                    class="dropdown-notifications-read"
                  >
                    <span
                      class="badge badge-dot"
                      [ngClass]="{
                        'update-alert': item.notificationType == 0,
                        'check-reminder': item.notificationType == 1,
                        event: item.notificationType == 2,
                        'expire-date': item.notificationType == 3,
                        'need-to-buy': item.notificationType == 4
                      }"
                    ></span>
                  </a>
                </div>
                <div class="col-12">
                  <p class="mb-1">{{ item.title }}</p>
                </div>
              </ng-container>
              <div class="close-notification-buttom">
                <button
                  type="button"
                  class="dropdown-notifications-archive"
                  (click)="closeItem(item, i)"
                >
                  <span class="bx bx-x"></span>
                </button>
              </div>
            </div>
          </li>
        </ng-container>
      </ul>
    </li>

    <li class="dropdown-menu-footer border-top">
      <a
        routerLink="/Notifications"
        routerLinkActive="true"
        class="dropdown-item d-flex justify-content-center p-3"
      >
        {{ "AllNotification" | translate }}
      </a>
    </li>
  </ul>
</li>
